import React, { useEffect, useState } from "react"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"
import { round2Digits, spacedNum } from "../../../common/CommonHelper"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { CommonFileInput } from "../../../common/element/fields/CommonFileInput"
import { CommonFileList } from "../../../common/element/fields/CommonFileList"
import { CommonInput } from "../../../common/element/fields/CommonInput"
import { CurrencyPicker } from "../../../common/element/fields/CurrencyPicker"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { ICalculateReplenishmentDto } from "../../../../types/replenishment/ICalculateReplenishmentDto"
import { ICalculateReplenishmentResponse } from "../../../../types/replenishment/ICalculateReplenishmentResponse"

export const PaymentTab: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
  errorModel: IErrorModel | undefined
  sending: boolean
  submit: (r: IReplenishmentDto) => void
  reject: () => void
}> = ({ replenishment, setReplenishment, errorModel, submit, reject }) => {
  const [message, setMessage] = useState<IModalMessage | null>(null)
  const [rateError, setRateError] = useState<string | undefined>()
  const [calculationRequestBefore, setCalculationRequestBefore] = useState<ICalculateReplenishmentDto>()
  const [calculationResponseBefore, setCalculationResponseBefore] = useState<ICalculateReplenishmentResponse>()
  const [invoiceAmount, setInvoiceAmount] = useState<string | undefined>(
    (Number(replenishment.invoiceAmount) / 100).toString()
  )
  const [showEdit, setShowEdit] = useState(false)

  useEffect(() => {
    TrinityAPI.getCompany(replenishment.companyId || "", response => {
      if (response.status === 200) {
        setCalculationRequestBefore({
          ...calculationRequestBefore,
          replenishmentId: replenishment.id,
          companyId: response.data.id,
          clientRate: replenishment.clientRate,
          personalRate: replenishment.personalRate,
          rate: replenishment.rateBefore,
          xRate: replenishment.xRateBefore,
          userId: replenishment.userId,
          invoiceAmount: replenishment.invoiceAmount
        })
      } else {
        setMessage({
          title: "Ошибка!",
          text: `Ошибка получения компании: ${response.data.message}`
        })
      }
    })
  }, [])

  useEffect(() => {
    if (
      calculationRequestBefore?.rate &&
      calculationRequestBefore.xRate &&
      calculationRequestBefore.invoiceAmount &&
      calculationRequestBefore.clientRate
    ) {
      TrinityAPI.calculateReplenishment(calculationRequestBefore, "before", response => {
        if (response.status === 200) {
          setCalculationResponseBefore(response.data)
          validateClientRate(response.data.calculationRate)
        } else {
          setMessage({
            title: "Ошибка!",
            text: `Ошибка отправки курса: ${response.data.message}`
          })
        }
      })
    }
  }, [calculationRequestBefore])

  const validateClientRate = (calculationRate: string) => {
    if (calculationRequestBefore && calculationRequestBefore.clientRate) {
      if (Number(calculationRequestBefore.clientRate) < Number(calculationRate)) {
        setRateError(`Ставка не может быть ниже ${calculationRate}%`)
      } else if (Number(calculationRequestBefore.clientRate) > 5.5) {
        setRateError(`Ставка не может выше 5.5%`)
      } else {
        setRateError(undefined)
      }
    }
  }

  useEffect(() => {
    if (invoiceAmount) {
      setCalculationRequestBefore({
        ...calculationRequestBefore,
        invoiceAmount: round2Digits(Number(invoiceAmount.replaceAll(" ", "")) * 100).toString()
      })
    }
  }, [invoiceAmount])

  // const getCalculationRateBefore = (): number => {
  //   let calculationRate = Number(replenishment.offeredRate)
  //   if (replenishment.clientRate) {
  //     calculationRate = Number(replenishment.clientRate)
  //   } else {
  //     calculationRate = calculateCommonRate(calculationRate)
  //   }
  //   return calculationRate
  // }

  const getPercentRate = () => {
    let calculationRate = Number(replenishment.offeredRate)
    if (replenishment.clientRate) {
      calculationRate = Number(replenishment.clientRate)
    } else {
      if (Number(replenishment.amountRate) > 0) {
        calculationRate = Number(replenishment.amountRate)
      }
      if (Number(replenishment.volumeRate) > 0 && Number(replenishment.volumeRate) < Number(calculationRate)) {
        calculationRate = Number(replenishment.volumeRate)
      }
    }
    return calculationRate
  }

  const getOnTopAmount = () => {
    if (replenishment.onTopAmount) {
      return ` + ${spacedNum(Number(replenishment.onTopAmount) / 100)} USD`
    }

    return ""
  }

  // const calculateCommonRate = (calculationRate: number): number => {
  //   if (replenishment.amountRate && Number(replenishment.amountRate) > 0) {
  //     calculationRate = Number(replenishment.amountRate)
  //   }
  //   if (
  //     replenishment.volumeRate &&
  //     Number(replenishment.volumeRate) > 0 &&
  //     Number(replenishment.volumeRate) < calculationRate
  //   ) {
  //     calculationRate = Number(replenishment.volumeRate)
  //   }
  //   return calculationRate
  // }

  const showShowEdit = () => {
    setShowEdit(true)
    setReplenishment({ ...replenishment, paymentOrders: [] })
  }

  const doSubmit = () => {
    if ((!replenishment.paymentOrders || replenishment.paymentOrders.length === 0) && !showEdit) {
      setMessage({ title: "Ошибка!", text: "Загрузите платежные поручения" })
      return
    }
    if (showEdit) {
      if (!calculationRequestBefore?.rate) {
        setMessage({ title: "Ошибка!", text: `Заполните ставку` })
        return
      }
      if (calculationRequestBefore?.clientRate) {
        if (Number(calculationRequestBefore.clientRate.replaceAll(" ", "")) > 5.5) {
          setMessage({ title: "Ошибка!", text: `Ставка не может быть выше 5.5%` })
          return
        }
        if (
          Number(calculationRequestBefore.clientRate.replaceAll(" ", "")) <
          Number(calculationResponseBefore?.calculationRate)
        ) {
          setMessage({
            title: "Ошибка!",
            text: `Ставка не может быть ниже предложенной ставки (${Number(
              calculationResponseBefore?.calculationRate
            )}%)`
          })
          return
        }
      }
      if (!calculationResponseBefore?.usdAmount || !calculationResponseBefore.rubAmount) {
        setMessage({ title: "Ошибка!", text: "Произошла ошибка при проведении расчетов" })
        return
      }
      const toSubmit = replenishment
      toSubmit.usdAmountBefore = calculationResponseBefore.usdAmount
      toSubmit.rubAmountBefore = calculationResponseBefore.rubAmount
      toSubmit.rubAmountAfter = calculationResponseBefore.rubAmount
      toSubmit.rateBefore = calculationRequestBefore.rate
      toSubmit.xRateBefore = calculationRequestBefore.xRate
      toSubmit.clientRate = calculationRequestBefore.clientRate
      toSubmit.invoiceAmount = (Number(invoiceAmount?.toString().replaceAll(" ", "")) * 100).toString()
      submit(toSubmit)
    } else {
      submit(replenishment)
    }
  }

  if (replenishment.status === "DOC") {
    return (
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Документы отправлены!</h4>
              <p className="message-course-yes">
                Ваши документы успешно отправлены и находятся на проверке у менеджера. Это может занять некоторое время.
                В случае успешной проверки вы сможете продолжить оформление. В противном случае будет необходимо внести
                исправления в соответствии с комментариями менеджера
              </p>
            </li>
          </ul>
        </div>
      </div>
    )
  } else {
    return (
      <>
        <ModalPopUp message={message} close={() => setMessage(null)} />
        <div className="container">
          <div className="container-pop-up">
            {(replenishment.status === "BILL_PAID" || replenishment.status === "CR_FIX") && (
              <p className="message-course-yes">
                Платежные поручения отправлены. После проверки менеджер произведет фиксацию курса и ваш баланс будет
                пополнен
              </p>
            )}
            <ul className="form-left">
              <div className="course-apply_block width-full">
                {/* <div className="headr-chapter-name">
                  <li className="course-item">
                    <div className="header-chapter-icon">
                      <img src={IMG.companies} alt="" className="header-chapter-img" />
                    </div>
                    <div className="flex-column-5">
                      <p className="main-header-item-text">
                        <span className="course-usd-header">1</span> /&nbsp;
                        <span className="course-rub-header">
                          {round4Digits(
                            Number(replenishment.rateBefore) +
                              (Number(replenishment.rateBefore) / 100) * getCalculationRateBefore()
                          )}
                        </span>
                      </p>
                      <p className="course-status">Курс к рублю до фиксации</p>
                    </div>
                  </li>
                </div> */}
                <div className="replenishment__payment-grid width-full">
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Курс валюты инвойса до фиксации</h4>
                    <p className="valute-deal-user--small">
                      {replenishment.invoiceCurrency} 1 / {replenishment.brockmanRateBefore} RUB
                    </p>
                  </li>
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Сумма пополнения в валюте</h4>
                    <p className="valute-deal-user--small">{spacedNum(Number(replenishment.usdAmountBefore) / 100)}$</p>
                  </li>
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Ставка</h4>
                    <p className="valute-deal-user--small">
                      {getPercentRate()}%{getOnTopAmount()}
                    </p>
                  </li>
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Сумма инвойса в рублях</h4>
                    <p className="valute-deal-user--small">
                      {spacedNum(round2Digits(Number(replenishment.rubAmountBefore) / 100))} ₽
                    </p>
                  </li>
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Кросс курс платформы до фиксации</h4>
                    <p className="valute-deal-user--small">{replenishment.xRateBefore}</p>
                  </li>
                </div>
                <ul className="course-flex-block flex-wrap-mobile">
                  <li className="course-status-block">
                    {/* <p className="course-summ-rub">
                      {spacedNum(round2Digits(Number(replenishment.rubAmountBefore) / 100))}
                    </p> */}
                    <p className="course-summ-rub-percent">
                      <span>Пополнение счета</span>
                      Пополнение №{replenishment.id}
                    </p>
                  </li>
                </ul>
                {showEdit ? (
                  <></>
                ) : (
                  <div className="flex-row-10">
                    <button
                      className="btn black-btn"
                      onClick={() => window.open(`/replenishment/${replenishment.id}/bill`)}
                    >
                      Открыть счет
                    </button>
                  </div>
                )}
              </div>

              {showEdit ? (
                <li className="form-block-popup">
                  <h4 className={`heading-chapter`}>Инвойс</h4>
                  <div className="flex-row-10">
                    <CommonInput
                      typeName={"date"}
                      label={"Дата"}
                      placeholder={""}
                      name={"invoiceDate"}
                      value={replenishment.invoiceDate}
                      errorModel={errorModel}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          invoiceDate: e
                        })
                      }
                    />
                    <CommonInput
                      typeName={"text"}
                      label={"Номер"}
                      placeholder={"Введите номер инвойса"}
                      name={"invoiceNumber"}
                      value={replenishment.invoiceNumber}
                      errorModel={errorModel}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          invoiceNumber: e
                        })
                      }
                    />
                    <CommonFileInput
                      label={"Инвойс (файл)"}
                      placeholder={replenishment.invoice?.b64 || replenishment.invoicePath ? "Заменить" : "Загрузить"}
                      name={"invoice"}
                      errorModel={errorModel}
                      _callback={f => setReplenishment({ ...replenishment, invoice: f })}
                      clazzName="fieldset-fit"
                    />
                  </div>
                  <div className="flex-row-10">
                    <CommonInput
                      typeName={"number"}
                      label={"Сумма"}
                      placeholder={"Введите сумму"}
                      name={"invoiceAmount"}
                      value={invoiceAmount}
                      errorModel={errorModel}
                      _callback={e => setInvoiceAmount(e)}
                    />
                    <CurrencyPicker
                      label={"Валюта"}
                      name={"invoiceCurrency"}
                      errorModel={errorModel}
                      initValue={replenishment.invoiceCurrency}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          invoiceCurrency: e
                        })
                      }
                      clazzName="fieldset-200"
                    />
                  </div>
                  <div className="flex-row-10">
                    <CommonInput
                      typeName={"number"}
                      label={`Ставка`}
                      placeholder={"Введите ставку"}
                      name={"calculationRate"}
                      value={calculationResponseBefore?.calculationRate}
                      errorModel={errorModel}
                      customError={rateError}
                      _callback={e => setCalculationRequestBefore({ ...calculationRequestBefore, clientRate: e })}
                    />
                    <CommonInput
                      typeName={"number"}
                      label={`Курс USD/${replenishment.invoiceCurrency}`}
                      placeholder={"Введите курс"}
                      name={"xRateBefore"}
                      value={calculationRequestBefore?.xRate}
                      errorModel={errorModel}
                      _callback={v => setCalculationRequestBefore({ ...calculationRequestBefore, xRate: v })}
                    />
                    <CommonInput
                      typeName={"number"}
                      label={"Курс USD/RUB"}
                      placeholder={"Введите курс для расчета"}
                      name={"rateBefore"}
                      value={calculationRequestBefore?.rate}
                      errorModel={errorModel}
                      _callback={v => setCalculationRequestBefore({ ...calculationRequestBefore, rate: v })}
                    />
                    <fieldset>
                      <legend className="legend-no-padding">Новая сумма в рублях</legend>
                      <p className="text-form">
                        {calculationResponseBefore?.rubAmount
                          ? spacedNum(Number(calculationResponseBefore.rubAmount) / 100)
                          : "-"}
                      </p>
                    </fieldset>
                  </div>
                  <CommonFileList file={replenishment.invoice} />
                </li>
              ) : replenishment.status === "CR_ACC" ? (
                <p className="message-course-yes">
                  Если вы внесли другую сумму, или изменился инвойс, воспользуйтесь кнопкой "Редактировать данные".
                  Внесите необходимые изменения. Важно, чтобы новая сумма в поле "Новая сумма в рублях" совпала с
                  внесенной вами суммой. После чего загрузите платежные поручения и нажмите "Отправить".
                </p>
              ) : (
                <></>
              )}
            </ul>
            {showEdit ? (
              <div className="right-form" />
            ) : (
              <div className="right-form">
                <div className="form-block-popup">
                  {replenishment.status === "CR_ACC" ? (
                    <>
                      <h4 className="heading-chapter">Платежные поручения</h4>
                      <CommonFileInput
                        label={"Документы"}
                        placeholder={
                          replenishment.paymentOrders && replenishment.paymentOrders?.length > 0
                            ? "Заменить"
                            : "Загрузить"
                        }
                        name={"paymentOrder"}
                        errorModel={errorModel}
                        multiple={true}
                        _callback={f => void 0}
                        _callbackMultiple={f =>
                          setReplenishment({
                            ...replenishment,
                            paymentOrders: f
                          })
                        }
                      />
                      <CommonFileList files={replenishment.paymentOrders} />
                    </>
                  ) : (
                    <h4 className="heading-chapter">Платежные поручения загружены</h4>
                  )}
                </div>
              </div>
            )}
            {replenishment.status === "CR_ACC" ? (
              <div className="flex-row-10 flex-wrap-mobile">
                <button className="btn" onClick={doSubmit}>
                  {showEdit ? "Сформировать счет по новым данным" : "Подтвердить"}
                </button>
                <button
                  className="btn black-btn"
                  onClick={() => (showEdit ? window.location.reload() : showShowEdit())}
                >
                  {showEdit ? "Вернуть как было" : "Редактировать данные"}
                </button>
                <button className="btn grey-btn" onClick={reject}>
                  Отменить оплату
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    )
  }
}
